import css from './input.scss';

const Input = (props) => {
    return (
        <div id={props.id} className={css.root}>
            <div className={`${css.leftPart} ${props.imgType === 'checkbox' ? css.leftPart__checkbox : ''}`}>
                {props.img ? (
                    <div>
                        <img src={props.img} alt={props.id} />
                    </div>
                ) : (props.imgType === 'checkbox' ? <input className={css.field} type={props.imgType} required={props.required ? 'required' : ''} /> : props.txt)
                }
            </div>
            <div className={css.rightPart}>
                <div className={css.rightPart__caption}>
                    <div className={css.rightPart__caption__name}><span>{props.caption}{`${props.required ? ' *' : ''}`}</span>{props.link ? <a href={props.link}>{props.linkText}</a> : ''}</div>
                    {props.captionDescription ? <span class={css.rightPart__caption__description}>{props.captionDescription}</span> : ""}

                </div>
                {props.type !== 'txt' ? (
                    <input className={css.field} type={props.type} required={props.required ? 'required' : ''} />
                ) :
                    ''
                }

                {props.errors ? <div className={css.error}><span>Поле обязательно для заполнения</span></div> : ''}
            </div>
        </div>
    );
}

export default Input;